import React from 'react'
import { HashRouter, useRoutes } from 'react-router-dom'

//引入 相关页面
import Load from './Templates'
import Share from './Templates/Share'

// App 路由配置
// const AppRouter = [
//   { path: '/', exact: true, component: Load },
//   { path: "/home", exact: true, component: Home },
//   { path: "/doc/start", exact: true, component: Doc },
//   { path: "/doc", exact: true, component: Doc },
//   { path: "/tostart", exact: true, component: ToStart },
// ]

// 渲染 App

const App = () => {
  const Routes = () => {
    const routes = useRoutes([
      { path: '/', element: <Load/> },
      { path: '/share', element: <Share/> },
    ])
    return routes;
  }

  return <>
    <HashRouter>
      <Routes/>
    </HashRouter>
  </>
}

export default App
